import { createContext, useContext, type ReactNode } from "react";
import type { CmsEntry, CmsKind } from "@/lib/cms";
import { publishedBlock, publishedList } from "@/lib/cms";

const CmsContext = createContext<CmsEntry[]>([]);

export function CmsProvider({ entries, children }: { entries: CmsEntry[]; children: ReactNode }) {
  return <CmsContext.Provider value={entries}>{children}</CmsContext.Provider>;
}

export function useCmsEntries(): CmsEntry[] {
  return useContext(CmsContext);
}

/** Published rows of a kind, falling back to the content shipped in code. */
export function useCmsList<T>(kind: CmsKind, fallback: T[]): T[] {
  return publishedList<T>(useContext(CmsContext), kind, fallback);
}

/** A single published text block, falling back to the copy shipped in code. */
export function useCmsBlock(key: string, fallback: string): string {
  return publishedBlock(useContext(CmsContext), key, fallback);
}
